import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { connect } from "react-redux";
import { capturePaymentButtonIntent, createPaymentButtonIntent } from "../../../../../redux/slices/paymentSlice";
import { buttonStyle, initialOptions } from "./paypal.data";
import { PAYMENT_METHOD_TYPE } from "../../../../../lib/constants/globalConstant";
import { showErrorSnackbar } from "../../../../../redux/slices/snackbarSlice";

const Paypal = ({ orderId, seasonId, handleOpenModal, capturePaymentIntent, paymentButtonIntent, showSnackbar, setPaymentIntentLoaded }) => {
  const handleCreateOrder = async () => {
    // data for payment-intent
    const data = {
      orderId,
      seasonId,
      paymentMethodType: PAYMENT_METHOD_TYPE.PAYPAL
    };

    try {
        const paymentResponse = await paymentButtonIntent(data);
        const orderData = await paymentResponse?.payload?.paymentResponseBody;
        if (!paymentResponse?.payload?.paymentResponseBody) {
          throw new Error("Failed to create the Payment order, try again later.");
        }    

        if(createPaymentButtonIntent.fulfilled.match(paymentResponse)){
            if (orderData?.id) {
                return orderData?.id;
            } else {
                const errorDetail = orderData?.details?.[0];
                const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                    : JSON.stringify(orderData);

                throw new Error(errorMessage);
            }
        }else {
          return null
        }
    } catch (error) {
        console.log("UNHANDLED ERROR =>", error);
        return null;
    }
  };

  // Error handling
  const handleOnError = (error) => {
    const errorMessage = error?.message || "An unexpected error occurred.";
    showSnackbar({ title: errorMessage });
  }
  
  // Handling Canceling/Closing
  const handleOnCancel = (walletType) => {
    const cancelMessage = `User canceled the ${walletType} checkout.`;
    showSnackbar({ title: cancelMessage });
  }

  // Handling Component Load (when component mounts/loaded/initialized)
  const handleOnComponentLoad = (walletType) => {
    try {
      setPaymentIntentLoaded((prev) => ({ ...prev, [walletType]: true }));
    } catch (error) {
      console.error("Error loading PayPal component:", error);
      showSnackbar({ title: "Error loading payment components. Please try again later." });
    }
  }
  
  // Handling Approval
  const handleOnApprove = async (approvedData, actions) => {
    // capture payment request-data
    const data = {
      orderId,
      paymentOrderId: approvedData.orderID,
      seasonId,
    };

    try {
        const captureResponse = await capturePaymentIntent(data);      
        
        if(capturePaymentButtonIntent.fulfilled.match(captureResponse)){
          const orderData = await captureResponse?.payload?.paypalResponseBody;
          const errorDetail = orderData?.details?.[0];
            // Three cases to handle:
            //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            //   (2) Other non-recoverable errors -> Show a failure message
            //   (3) Successful transaction -> Show confirmation or thank you message
    
          if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
            // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
            return actions.restart();
          } else if (errorDetail) {
            // (2) Other non-recoverable errors -> Show a failure message
            handleOpenModal("failed")
            throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
          } else {
            // (3) Successful transaction -> Show confirmation or thank you message
            // Or go to another URL:  actions.redirect('thank_you.html');
            // const transaction = orderData.purchase_units[0].payments.captures[0];
            handleOpenModal("succeeded")
          }
        }
    } catch (error) {
        console.log("UNHANDLED ERROR =>", error);
        return null;
    }
  };

  return (
    <>
      <PayPalScriptProvider options={initialOptions}>
        {/* Venmo Button */}
        {/* <PayPalButtons
          fundingSource={"venmo"}
          style={buttonStyle}
          createOrder={handleCreateOrder}
          onApprove={handleOnApprove}
          onError={handleOnError}
          onCancel={() => handleOnCancel("venmo")}
          onInit={() => handleOnComponentLoad("venmo")}
        /> */}
        
        {/* Paypal Button */}
        <PayPalButtons
          fundingSource={"paypal"}
          style={buttonStyle}
          createOrder={handleCreateOrder}
          onApprove={handleOnApprove}
          onError={handleOnError}
          onCancel={() => handleOnCancel("paypal")}
          onInit={() => {
            handleOnComponentLoad("paypal");
            // handleOnComponentLoad("venmo"); // REMOVE THIS
          }}
        />
      </PayPalScriptProvider>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  paymentButtonIntent: (data) => dispatch(createPaymentButtonIntent(data)),
  capturePaymentIntent: (data) => dispatch(capturePaymentButtonIntent(data)),
  showSnackbar: (data) => dispatch(showErrorSnackbar(data)),
});

export default connect(null, mapDispatchToProps)(Paypal);